import { AssetTypes } from 'libs.localization.common';
import { ParticipantStatusesPreview, ProtocolSchedulePreview, ResourcesPreview, SignInSupportInformationPreview, StudyNameWithPIIPreview, StudyNameWithNoPIIPreview, ActivityNamesPreview, SiteVisitSchedulePreview, ResourceTitlesPreview, PushNotificationPreview, EmailPreview, SmsPreview, } from './components';
export const previewComponents = {
    [AssetTypes.PARTICIPANT_STATUSES]: ParticipantStatusesPreview,
    [AssetTypes.PROTOCOL_SCHEDULE]: ProtocolSchedulePreview,
    [AssetTypes.SIGN_IN_STUDY_NAME_PII]: StudyNameWithPIIPreview,
    [AssetTypes.SIGN_IN_STUDY_NAME]: StudyNameWithNoPIIPreview,
    [AssetTypes.SITE_VISIT_SCHEDULE]: SiteVisitSchedulePreview,
    [AssetTypes.SIGN_IN_SUPPORT_INFORMATION]: SignInSupportInformationPreview,
    [AssetTypes.RESOURCES]: ResourcesPreview,
    [AssetTypes.ACTIVITY_NAMES]: ActivityNamesPreview,
    [AssetTypes.RESOURCE_TITLES]: ResourceTitlesPreview,
    [AssetTypes.NOTIFICATION_PUSH_NOTIFICATION]: PushNotificationPreview,
    [AssetTypes.NOTIFICATION_EMAIL]: EmailPreview,
    [AssetTypes.NOTIFICATION_SMS]: SmsPreview,
};
//# sourceMappingURL=preview_component_mapping.js.map